import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authService: AuthService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.currentUserValue) {
      const userRole = this.authService.currentUserValue.Role;
      if (route.data.role && route.data.role.indexOf(userRole) === -1) {
        if (isPlatformBrowser(this.platformId)) {
          this.router.navigate(['/authentication/signin']);
        }
        return false;
      }
      return true;
    }

    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate(['/authentication/signin']);
    }
    return false;
  }
}
